
import React from "react";
import globalGetPadding from "../../utils/getPadding";

var ColumnsContainerPropsDefaults = {
    columnsCount: 2,
    columnsGap: 0,
    contentAlignment: 'middle',
    equalHeightColumns: false,
};
function getContentJustify(contentAlignment) {
    if (contentAlignment === 'top') {
        return 'flex-start';
    }
    if (contentAlignment === 'bottom') {
        return 'flex-end';
    }
    return 'center';
}
function TableCell(_a) {
    var _b, _c, _d, _e, _f;
    var index = _a.index, props = _a.props, columns = _a.columns, isMobile = _a.isMobile;
    var columnsCount = (_c = props === null || props === void 0 ? void 0 : props.columnsCount) !== null && _c !== void 0 ? _c : ColumnsContainerPropsDefaults.columnsCount;
    var contentAlignment = props?.contentAlignment ?? ColumnsContainerPropsDefaults.contentAlignment;
    var equalHeightColumns = props?.equalHeightColumns ?? ColumnsContainerPropsDefaults.equalHeightColumns;
    // if (columnsCount === 2 && index === 2) {
    //     return null;
    // }
    if (columnsCount <= index) {
        return null;
    }
    const _unit = props.fixedWidthsUnit ? props.fixedWidthsUnit[index] ? props.fixedWidthsUnit[index] : 'px' : 'px';
    const colWidth = props.fullWidthOnMobile && isMobile ? '100%' : ((_e = (_d = props.fixedWidths) === null || _d === void 0 ? void 0 : _d[index]) !== null && _e !== void 0 ? _e+_unit : undefined);
    var style = {
        boxSizing: 'content-box',
        paddingLeft: props.fullWidthOnMobile && isMobile ? 0 : getPaddingBefore(index, props),
        paddingRight: props.fullWidthOnMobile && isMobile ? 0 : getPaddingAfter(index, props),
        flex: colWidth ? 'unset' : 1,
        width: colWidth,
        display: equalHeightColumns && !(props.fullWidthOnMobile && isMobile) ? 'flex' : undefined,
        flexDirection: equalHeightColumns && !(props.fullWidthOnMobile && isMobile) ? 'column' : undefined,
        alignSelf: equalHeightColumns && !(props.fullWidthOnMobile && isMobile) ? 'stretch' : undefined,
    };
    var children = (_f = (columns && columns[index])) !== null && _f !== void 0 ? _f : null;
    return <div style={style}>
        <div style={equalHeightColumns && !(props.fullWidthOnMobile && isMobile) ? {
            flex: 1,
            minHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: getContentJustify(contentAlignment),
        } : undefined}>{children}</div>
    </div>;
}
function getPaddingBefore(index, _a) {
    var columnsGap = _a.columnsGap, columnsCount = _a.columnsCount;
    if (index === 0) {
        return 0;
    }
    const gap_total = columnsGap * (columnsCount - 1);
    const gap_col = gap_total / columnsCount;
    if(index === columnsCount - 1) {
        return gap_col;
    }
    else {
        return columnsGap*index - gap_col*index;
    }

    // if (index === 1) {
    //     return columnsGap / 3;
    // }
    // return (2 * columnsGap) / 3;
}
function getPaddingAfter(index, _a) {
    var columnsGap = _a.columnsGap, columnsCount = _a.columnsCount;
    if (index+1 === columnsCount) {
        return 0;
    }

    const gap_total = columnsGap * (columnsCount - 1);
    const gap_col = gap_total / columnsCount;
    if(index === 0) {
        return gap_col;
    }
    else {
        return gap_col*(index+1) - columnsGap*index;
    }
}

export const CustomColumnsContainer = (_a)=> {
    var _b, _c, _d, _e, _f;
    var style = _a.style, columns = _a.columns, props = _a.props, formClientWidth = _a.formClientWidth;
    const isMobile = formClientWidth <= 480;
    
    var contentAlignment = (_f = props === null || props === void 0 ? void 0 : props.contentAlignment) !== null && _f !== void 0 ? _f : ColumnsContainerPropsDefaults.contentAlignment;
    
    var wStyle = {
        display: 'flex',
        flexDirection: props.fullWidthOnMobile && isMobile ? 'column' : 'row',
        backgroundColor: (_b = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _b !== void 0 ? _b : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.padding, isMobile),
        alignItems: props?.equalHeightColumns && !(props.fullWidthOnMobile && isMobile) ? 'stretch' : contentAlignment === 'top' ? 'flex-start' : contentAlignment === 'bottom' ? 'flex-end' : 'center'
    };
    var blockProps = {
        columnsCount: (_c = props === null || props === void 0 ? void 0 : props.columnsCount) !== null && _c !== void 0 ? _c : ColumnsContainerPropsDefaults.columnsCount,
        columnsGap: (_d = props === null || props === void 0 ? void 0 : props.columnsGap) !== null && _d !== void 0 ? _d : ColumnsContainerPropsDefaults.columnsGap,
        contentAlignment: (_e = props === null || props === void 0 ? void 0 : props.contentAlignment) !== null && _e !== void 0 ? _e : ColumnsContainerPropsDefaults.contentAlignment,
        fixedWidths: props === null || props === void 0 ? void 0 : props.fixedWidths,
        fixedWidthsUnit: props === null || props === void 0 ? void 0 : props.fixedWidthsUnit,
        fullWidthOnMobile: props === null || props === void 0 ? void 0 : props.fullWidthOnMobile,
        equalHeightColumns: props === null || props === void 0 ? void 0 : props.equalHeightColumns,
    };
    return (<div style={wStyle}>
        {
            columns?.map((c_item, ind)=>
                <TableCell key={ind} index={ind} props={blockProps} columns={columns} isMobile={isMobile}/>
            )
        }
    </div>);
}

